import React from "react";
// import HttpService from '../../utils/Http.services';
// import { siteConfig, siteTheme } from "../../variables/config";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
// import TabBar from "../views/TabBar";
import Configurer from "../Configurer";
import ProfileImage from "../partials/ProfileImage";
// import TableViewer from "../TableViewer";
import { v4 as uuidv4 } from 'uuid';
import ItemModal from "../../modals/ItemModal";
import HttpServices from "../../utils/Http.services";
// import RemoveModal from "../../modals/RemoveModal";
import { checkTextTranslation, checkTranslation, pathMaker, translate } from "../../utils/useful";
// import ServiceBox from "../boxes/ServiceBox";
import DataGrid from "../DataGrid";
import Pagination from "../Pagination";
import OptionsListModal from "../../modals/OptionsListModal";
import RemoveConfirmationModal from "../../modals/RemoveConfirmationModal";


class BoxesView extends React.Component {


    openEditModal = (prop, index) => {
        // console.log(prop)
        this.itemModal.modal.showModal()
        this.setState({ currentItem: prop, currentIndex: index })
    }

    openRemoveModal = (prop, index) => {
        this.removeModal.modal.showModal()
        this.setState({ currentItem: prop, currentIndex: index })

        // console.log("remove")
    }

    state = {
        data: [],
        actions: {
            add: { key: "edit", label: '{{lang}}edit', color: '#677dc4', function: this.openEditModal },
            edit: { key: "remove", label: '{{lang}}remove', color: '#ee5050', function: this.openRemoveModal }
        },
        currentPage: 0,
        limit: 10
    }


    componentDidMount() {
        this.init()
    }

    componentDidUpdate(prevProps) {
        if (this.props.page !== prevProps.page) {
            // setTimeout(() => {
            this.init()
            // }, 500);
        }
    }


    init() {
        if (this.props.page) {
            this.setState({ data: [] }, () => {
                this.fetchData(true)
            })
        }
    }

    fetchData = (getCount) => {

        this.setState({ isLoadingData: true })
        let body = {}
        let page = this.props.page
        body.page = page.key
        body.limit = this.state.limit
        body.skip = this.state.currentPage

        if (page.filter) {
            body = { ...body, ...page.filter }
            // console.log(body)
        }

        if (this.state.totalCount == null || getCount) {
            body.getCount = true
        }

        // console.log(body)

        HttpServices.request(page.fetchUrl, body, (fetchResult, fetchError) => {
            this.setState({ isLoadingData: false })

            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
                return
            }
            // console.log(fetchResult)
            this.setState({ data: fetchResult.info })

            if (fetchResult.count) {
                this.setState({ totalCount: fetchResult.count })
            }
        })
    }


    fetchRemove = () => {
        this.setState({ isLoadingRemove: true })
        let id = this.state.currentItem._id
        HttpServices.request(this.props.page.removeUrl, { "id": id }, (fetchResult, fetchError) => {
            this.setState({ isLoadingRemove: false })

            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.removeFailed', description: fetchError.message })
                return
            }
            let data = this.state.data
            data.splice(this.state.currentIndex, 1)
            this.setState({ data })
            this.removeModal.modal.hideModal()
            this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.removedSuccesfully', description: '{{lang}}info.dataRemovedSuccessfully' })


        })

    }

    itemAdded = (newItem) => {
        let data = this.state.data
        data.splice(0, 0, newItem)
        // console.log(newItem)
        // console.log(data)
        this.setState(data)
    }

    itemEdited = (editedItem) => {
        // console.log(editedItem)
        let data = this.state.data
        this.state.data.forEach((element, index) => {
            let id = element.id ?? element._id
            let currentId = this.state.currentItem.id ?? this.state.currentItem._id
            if (id === currentId) {
                // console.log(id)
                data[index] = Object.assign({}, editedItem)
            }
        });
        this.setState({ data }, () => {
            // console.log(editedItem)
            // console.log(data)
            // this.TableViewer.forceUpdateData()
        })
    }

    // updateData = (data) => {
    //     this.setState(data)
    // }


    openAddNew = () => {
        if (this.props.page?.addNew) {
            this.props.history.push(pathMaker(this.props.page?.addNew + '?ref=' + pathMaker('/' + this.props.route + '/' + this.props.page?.key)))
        } else {
            this.openEditModal()
        }
    }


    changePage = (index) => {
        this.setState({ currentPage: index }, () => {
            this.fetchData()
        })
    }


    openOptions = (prop, index) => {
        // console.log(prop)
        let options
        if (prop.status == -1) {
            options = [
                { name: '{{lang}}View', icon: '/images/eye.svg', function: this.openView },
                { name: '{{lang}}Edit', icon: '/images/settings.svg', function: this.openEdit },
                { name: '{{lang}}Connect', icon: '/images/settings.svg', function: this.fetchConnect },
                { name: '{{lang}}Remove', description: 'remove this data', icon: '/images/remove.svg', function: this.openRemoveModal },
            ]
        } else {
            options = [
                { name: '{{lang}}View', icon: '/images/eye.svg', function: this.openView },
                { name: '{{lang}}Edit', icon: '/images/settings.svg', function: this.openEdit },
                { name: '{{lang}}Disconnect', icon: '/images/settings.svg', function: this.fetchDisconnect },

            ]
        }

        this.setState({ options, currentItem: prop, currentIndex: index }, () => {
            this.optionsModal.modal.showModal()
        })

    }


    openRemoveModal = () => {
        this.removeModal.modal.showModal()
    }


    openEdit = () => {
        this.itemModal.modal.showModal()
    }
    openView = () => {
        let id = this.state.currentItem._id
        this.props.history.push(pathMaker('/' + this.props.page.viewAddress + '/' + id))
    }


    fetchRemove = () => {
        this.setState({ isLoadingRemove: true })
        let id = this.state.currentItem._id
        HttpServices.request(this.props.page.removeUrl, { "id": id }, (fetchResult, fetchError) => {
            this.setState({ isLoadingRemove: false })

            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.removeFailed', description: fetchError.message })
                return
            }
            let data = this.state.data

            data.forEach((element, index) => {
                if (element._id == id) {
                    data.splice(index, 1)
                }
            });

            this.setState({ data })
            this.removeModal.modal.hideModal()
            this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.removedSuccesfully', description: '{{lang}}info.dataRemovedSuccessfully' })


        })

    }


    fetchDisconnect = () => {
        this.fetchStatus(-1)
    }

    fetchConnect = () => {
        this.fetchStatus(1)
    }



    fetchStatus = (newStatus) => {
        this.setState({ isLoadingRemove: true })
        let id = this.state.currentItem._id
        HttpServices.request('changeThingStatus', { "id": id, status: newStatus }, (fetchResult, fetchError) => {
            this.setState({ isLoadingRemove: false })

            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.removeFailed', description: fetchError.message })
                return
            }
            // console.log(this.state.currentIndex)
            let data = this.state.data

            data.forEach((element, index) => {
                if (element._id == id) {
                    data[index].status = newStatus
                }
            });

            this.setState({ data })
            // this.removeModal.modal.hideModal()
            this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.actionSuccesfully', description: '{{lang}}info.dataActionSuccessfully' })

        })
    }
    setData = (key, value, reference, cb) => {
        if (reference == 'BoxesView') {
            this.setState({ [key]: value }, () => {
                if (cb) {
                    cb()
                }
            })
        }
        else {
            if (this.props.setData) {
                this.props.setData(key, value, reference, () => {

                })
            }
        }
    }
    render() {
        // console.log( this.props.page?.actions)
        return (

            <Configurer
                settingsInfo={{ showFooter: true, showTabBar: true, showHeader: true, headerTitle: checkTextTranslation(this.props.page?.title), button: { goBack: true } }}
                title={checkTextTranslation(this.props.page?.title)}
                description={checkTextTranslation(this.props.page?.description)}
                className=""
            >


                <div className="container " >
                    <div className="row m-0">
                        <div className="col-12 p-0" >
                            <div className="p-0" style={{ borderRadius: 0 }}>

                                <div className="flexcb" style={{ flexWrap: 'wrap' }}>

                                    <div className="flexc mt-2">

                                        <ProfileImage setData={this.setData} width={54} borderRadius={50} notif={0} border={'2px solid #eee'} className={'mrd-3'} data={{ image: this.props.page?.image }} />

                                        <div>
                                            <p className="text-big font-bold m-0 " style={{ color: '#0d172a' }}>{checkTranslation(this.props.page?.title)}</p>
                                            <p className="text-small m-0" style={{ color: '#89a' }} >{checkTranslation(this.props.page?.description)}</p>
                                        </div>
                                    </div>


                                    <div className="flexcc mt-2" style={{ alignItems: 'flex-end' }}>
                                        {this.props.page?.addNew != -1 && (
                                            <button onClick={() => this.openAddNew()} className="flexcc" style={{ boxShadow: '0px 0px 15px #00000005', backgroundImage: 'linear-gradient(#000,#102030)', border: '0px solid #e9eaf0', color: '#789', borderRadius: 30, padding: '7px 15px' }}>
                                                <img className="mrd-2 invert" src="/images/add.svg" alt="" width="12px" />
                                                <span className="text-smaller m-0 white text-bold" >{translate('Add New')}</span>
                                            </button>
                                        )}
                                    </div>

                                </div>
                            </div>

                        </div>



                        <div className="col-12 mb-5 mt-4 w-100 p-0">


                            <DataGrid setData={this.setData} hideLoader={true} width={this.props.width} isLoading={this.state.isLoadingData} data={this.state.data} component={this.props.page?.box} col={this.props.page?.grid ?? { xs: "12", sm: '6', md: '6', lg: "4", xl: "4" }} settings={{ edit: (this.props.page?.actions && Object.keys(this.props.page?.actions).length) > 0 ? true : false, openOptions: this.openOptions }} />

                            <Pagination setData={this.setData} currentPage={this.state.currentPage} totalCount={this.state.totalCount} limit={this.state.limit} changePage={this.changePage} />
                        </div>


                    </div>


                    <ItemModal
                        ref={el => this.itemModal = el}
                        page={this.props.page}
                        headers={this.props.page?.headers}
                        initData={this.state.currentItem}
                        itemAdded={this.itemAdded}
                        itemEdited={this.itemEdited}
                    />



                    <OptionsListModal ref={el => this.optionsModal = el}
                        options={this.state.options}
                    />

                    <RemoveConfirmationModal ref={el => this.removeModal = el} confirmed={this.fetchRemove} />




                </div>
            </Configurer>
        )
    }


}



const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(BoxesView);
